module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "app-container",
    class: _vm.$route.name,
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), " ", _h('div', {
    staticClass: "modal-controls"
  }), " ", _vm._m(1), " ", _h('div', {
    staticClass: "modal-mask"
  }), " ", _vm._m(2), " ", _h('progress-bar', {
    key: _vm.$route.fullPath
  }), " ", _h('view-container')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "app-logo"
  }, [_h('div', {
    staticClass: "app-logo__inner"
  }, [_h('img', {
    staticClass: "app-logo__image",
    attrs: {
      "src": require("../src/assets/svg/logo.svg"),
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "modal-container"
  }, [_h('div', {
    staticClass: "modal-container__inner"
  }, [_h('div', {
    staticClass: "modal-container__wrap"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "view-loader"
  }, [_h('div', {
    staticClass: "view-loader__panel"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b9ba20ae!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 224
// module chunks = 2